import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';
import { Company } from 'src/secret-menu/hooks/useCompanies';
import { SectionType, UploadedTemplate } from 'src/data-capture/hooks/templates/useTemplates';
import { MarkdownImageCollection } from 'src/company/templates/hooks/useConvertToMarkdownMutation';

export type TemplateCreationData = {
  company: Company;
  templateType?: TemplateType;
  templateName: string;
  templateDescription: string;
  exampleTemplateFile?: UploadedFile;
  examplePopulatedFile?: UploadedFile;
  exampleTemplateMarkdown?: string;
  examplePopulatedMarkdown?: string;
  markdownSplitLevel: SectionSplittingLevel;
  templateSections: TemplateSectionCreationData[];
  createdTemplate?: UploadedTemplate;
  extractedImagesCollection: MarkdownImageCollection | null;
  previewClientId?: string | null;
  importedFromJson?: boolean;
  meetingNoteTense?: MeetingNoteTense;
  eligibleForSummarisation?: boolean;
  sectionSplittingLevel: SectionSplittingLevel | null;
};

export type TemplateType =
  | 'MEETING_NOTE'
  | 'MEETING_AGENDA'
  | 'SUITABILITY_REPORT'
  | 'CLIENT_INFORMATION_DOCUMENT';

export type MeetingNoteTense = 'THIRD_PERSON' | 'FIRST_SECOND_PERSON';

export type TemplateSectionCreationData = {
  id: string;
  sectionHeader: string;
  sectionHeaderLevel: number;
  templatedMarkdown: string;
  isSectionInPopulatedMarkdown?: boolean;
  populatedMarkdown?: string;
  sectionInstructions?: string;
  preserveAsIs: boolean;
  isContentComplete: boolean;
  agent?: string;
  domainFilter?: string[];
  addPageBreakAfterSection?: boolean;
  sectionType?: SectionType;
  tableOfContentsDepth?: number;
  addCoverPageBeforeSection?: boolean;
};

export type SectionSplittingLevel = 1 | 2 | 3 | 4 | 5 | 6;

export type TableOfContentsDepth = 1 | 2 | 3 | 4;

export const DEFAULT_TABLE_OF_CONTENTS_DEPTH: TableOfContentsDepth = 2;

export const DEFAULT_TABLE_OF_CONTENTS_TITLE = 'Contents';

export type TemplateExportData = {
  version: 1;
  templateType: TemplateType;
  templateName: string;
  templateDescription: string;
  markdownSplitLevel: SectionSplittingLevel;
  sections: ExportedTemplateSection[];
  meetingNoteTense?: MeetingNoteTense;
  eligibleForSummarisation?: boolean;
  sectionSplittingLevel?: SectionSplittingLevel | null;
};

export type ExportedTemplateSection = {
  sectionHeader: string;
  sectionHeaderLevel: number;
  templatedMarkdown: string;
  populatedMarkdown?: string;
  sectionInstructions?: string;
  preserveAsIs: boolean;
  agent?: string;
  domainFilter?: string[];
  addPageBreakAfterSection?: boolean;
  sectionType?: SectionType;
  tableOfContentsDepth?: number;
  addCoverPageBeforeSection?: boolean;
};
